import { render, staticRenderFns } from "./PublisherMarketplace.vue?vue&type=template&id=352141eb&scoped=true&"
import script from "./PublisherMarketplace.vue?vue&type=script&lang=js&"
export * from "./PublisherMarketplace.vue?vue&type=script&lang=js&"
import style0 from "./PublisherMarketplace.vue?vue&type=style&index=0&id=352141eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352141eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAvatar,VCard,VCardText,VChip})
